import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import mainGoalsPopupContentQueryParameters from '@atlassian/jira-business-goal-picker/src/ui/goals-popup-content/__generated__/GoalsPopupQuery.graphql';

const GoalsEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-goals-edit-view" */ './ui/goals'),
	),
	getPreloadProps: ({ cloudId, issueAri }: { cloudId: string; issueAri: string }) => ({
		queries: {
			GoalsPopupQuery: {
				parameters: mainGoalsPopupContentQueryParameters,
				variables: {
					cloudId,
					issueAri,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});

export default GoalsEditViewEntryPoint;
